/**
 * What the stamp book looked like last time, per correspondent — so a stamp
 * spent since then can leave a postmarked gap that fades to an empty slot,
 * once. Per-viewer, best-effort: without storage the gap simply never shows.
 */

const KEY = 'toiyp:stamp-book-held';

function read(): Record<string, number> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}') as Record<string, number>;
  } catch {
    return {};
  }
}

/** Stamps spent since the last look (0 the first time), and remember `held` now. */
export function spentSinceLastLook(relationshipId: string, held: number): number {
  const seen = read();
  const before = seen[relationshipId];
  seen[relationshipId] = held;
  try {
    localStorage.setItem(KEY, JSON.stringify(seen));
  } catch {
    /* ignore */
  }
  return before != null && before > held ? before - held : 0;
}

/** The first of next month (UTC) — when a month's Express allowance arrives. */
export function nextRefill(now: Date = new Date()): Date {
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1));
}

/** Seal-moment pause: long enough to see the postmark land; none for reduced motion. */
export function sealPause(): Promise<void> {
  let reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    /* ignore */
  }
  return new Promise((resolve) => setTimeout(resolve, reduce ? 0 : 750));
}
